import React from "react";
import moment from "moment";
import DatePicker from "../../../components/DatePicker";
import images from "../../../utils/images";
import { BENEFIT_SHEET_TABS } from "../constants";
import BenefitPreviewCard from "./BenefitPreviewCard";
import FireExplosionCompanySelector from "./FireExplosionCompanySelector";
import FireExplosionPackageButton from "./FireExplosionPackageButton";

export default function FireExplosionPackagesPanel({
  packages,
  selectedId,
  onSelectPackage,
  companyVariants,
  selectedVariantKey,
  onSelectVariant,
  dateEffect,
  onDateChange,
  minDateEffect,
  maxDateEffect,
  onOpenBenefitSheet,
}) {
  const isFutureDate = dateEffect
    ? moment(dateEffect).startOf("date").isAfter(moment().startOf("date"))
    : false;

  const endDate = dateEffect
    ? (isFutureDate
      ? moment(dateEffect).add(12, "months").subtract(1, "day")
      : moment(dateEffect).add(12, "months")
    ).format("DD/MM/YYYY")
    : "";

  return (
    <div className="fire-explosion__packages-panel">
      <div className="fire-explosion__packages-row">
        {packages.map((pkg) => (
          <FireExplosionPackageButton
            key={pkg.id}
            pkg={pkg}
            active={pkg.id === selectedId}
            onSelect={() => onSelectPackage(pkg.id)}
          />
        ))}
      </div>

      <FireExplosionCompanySelector
        variants={companyVariants}
        selectedVariantKey={selectedVariantKey}
        onSelectVariant={onSelectVariant}
      />

      {/* Thời hạn bảo hiểm */}
      <div className="fire-explosion__date-section">
        <h2 className="fire-explosion__section-title fire-explosion__section-title--date">
          Thời hạn bảo hiểm
        </h2>
        <div className="fire-explosion__date-section-content">
          <div className="fire-explosion__date-row">
            <div className="fire-explosion__date-col">
              <span className="fire-explosion__date-label">Ngày hiệu lực</span>
              <div className="fire-explosion__date-box fire-explosion__date-box--picker">
                <DatePicker
                  error={false}
                  title="Chọn ngày hiệu lực"
                  minDate={minDateEffect}
                  maxDate={maxDateEffect}
                  date={dateEffect}
                  defaultDate={dateEffect}
                  onChange={onDateChange}
                />
              </div>
            </div>
            <div className="fire-explosion__date-col">
              <span className="fire-explosion__date-label">Ngày kết thúc</span>
              <div className="fire-explosion__date-box fire-explosion__date-box--readonly">
                <span className="fire-explosion__date-val">{endDate}</span>
                <img
                  src={images.icon_calendar}
                  alt="calendar"
                  className="fire-explosion__date-calendar-icon"
                />
              </div>
            </div>
          </div>

          <div className="fire-explosion__date-duration-pill">
            <span>Thời hạn: 12 tháng</span>
            <svg
              className="fire-explosion__date-duration-chevron"
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </div>

          <div className="fire-explosion__date-note">
            <span className="fire-explosion__date-note-icon" aria-hidden>
              ✓
            </span>
            <span className="fire-explosion__date-note-text">
              Bạn được bảo vệ ngay sau khi thanh toán thành công
            </span>
          </div>
        </div>
      </div>

      <BenefitPreviewCard
        onOpenBenefitSheet={() => onOpenBenefitSheet(BENEFIT_SHEET_TABS.detail)}
      />
    </div>
  );
}
